module.exports = __webpack_public_path__ + "img/loader.c09926ed.gif";